<template>
  <div class="ag-cell-header-action-icons-wrapper">
    <div v-for="icon in icons" :key="icon.name" class="cursor--pointer">
      <MdButton
        v-if="icon.asButton"
        v-tooltip="{
          content: icon.tooltipContent,
          placement: icon.tooltipPlacement,
          disabled: !icon.tooltipContent
        }"
        :data-qa-id="fieldName + '-' + icon.name"
        size="small"
        variant="ghost"
        :color="icon.buttonColor || 'red'"
        @click="handleActionClick(icon.name)"
        @mouseover="iconButtonHover = true"
        @mouseleave="iconButtonHover = false"
      >
        <component
          :is="iconsMap[icon.name]"
          :color="iconButtonHover ? icon.hoverColor : icon.color || 'spirits--600'"
          :colorhover="icon.hoverColor"
          :customalttext="icon.name"
        />
      </MdButton>
      <component
        :is="iconsMap[icon.name]"
        v-else
        v-tooltip="{
          content: icon.tooltipContent,
          placement: icon.tooltipPlacement,
          disabled: !icon.tooltipContent
        }"
        :data-qa-id="fieldName + '-' + icon.name"
        :color="icon.color || 'spirits--600'"
        :colorhover="icon.hoverColor"
        :customalttext="icon.name"
        @click="handleActionClick(icon.name)"
      />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { MdIconEdit, MdIconTrash, MdIconDocument, MdButton } from '@antiqua-dls/vue-components';
import { ACTIONS } from 'src/utils/constants/common';

// Define the component name
defineOptions({
  name: 'ActionCellRenderer'
});

const iconsMap = {
  [ACTIONS.edit]: MdIconEdit,
  [ACTIONS.delete]: MdIconTrash,
  [ACTIONS.note]: MdIconDocument
};

// define the props
const props = defineProps({
  params: {
    type: Object,
    default: () => ({})
  }
});

const { fieldName, icons = [], actionHandler } = props.params;

const iconButtonHover = ref(false);

const handleActionClick = actionName => {
  if (actionHandler) {
    actionHandler({
      action: actionName,
      data: props.params.data
    });
  }
};
</script>

<!-- Scoped CSS does npt work in AgGrid renderer components, so we use global styles -->
<style>
.ag-cell-header-action-icons-wrapper {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  vertical-align: middle;
  gap: var(--md-spacing-unit--xs);
  width: 100%;
}
</style>
